// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NotFound_wrapper__3-Ec9 .ant-empty-image {\n  height: 152px;\n  margin-bottom: 16px; }\n\n.NotFound_wrapper__3-Ec9 .ant-empty-footer > span {\n  color: #9b9b9b;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "NotFound_wrapper__3-Ec9"
};
module.exports = exports;
